import { Injectable } from '@angular/core';

import { HttpClient as Http } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable()
export class APIClientService {
  constructor(private http: Http) {}

  doPost(url: string, request: any, httpOptions?: any): Observable<any> {
    if (httpOptions) {
      return this.http.post(url, request, httpOptions);
    } else {
      return this.http.post(url, request);
    }
  }

  doGet(url: string, params?: any): Observable<any> {
    if (params) {
      return this.http.get(url, params);
    } else {
      return this.http.get(url);
    }
  }
}
